import { useEffect, useRef, useState } from 'react';

import { useUser } from 'shared/hooks/api/user';
import {
  HandoverPreferencesResponse,
  useHandoverPreferences,
  useUpdateHandoverPreferences,
} from 'events/hooks/useHandoverPreferences';

interface UseDaySummaryStateResult {
  summaryExpanded: boolean;
  editingPreferences: boolean;
  handoverPreferences: HandoverPreferencesResponse | undefined;
  isSavingPreferences: boolean;
  setSummaryExpanded: (next: boolean) => void;
  setEditingPreferences: (next: boolean) => void;
  handleSavePreferences: (preferences: string[]) => void;
}

export default function useDaySummaryState(): UseDaySummaryStateResult {
  const [summaryExpanded, setSummaryExpanded] = useState(false);
  const [editingPreferences, setEditingPreferences] = useState(false);

  const { data: user } = useUser();
  const { data: handoverPreferences } = useHandoverPreferences();
  const { mutate: updateHandoverPreferences, isPending: isSavingPreferences } =
    useUpdateHandoverPreferences();

  const hasInitializedPreferenceView = useRef(false);
  useEffect(() => {
    if (!user || hasInitializedPreferenceView.current) return;
    hasInitializedPreferenceView.current = true;
    if (!user.member.handover_preferences?.length) {
      setEditingPreferences(true);
    }
  }, [user]);

  const handleSavePreferences = (preferences: string[]) => {
    updateHandoverPreferences(
      { handover_preferences: preferences },
      { onSuccess: () => setEditingPreferences(false) }
    );
  };

  return {
    summaryExpanded,
    editingPreferences,
    handoverPreferences,
    isSavingPreferences,
    setSummaryExpanded,
    setEditingPreferences,
    handleSavePreferences,
  };
}
